import { call, put, takeLatest, cancelled, all } from "redux-saga/effects"
import { push } from "connected-react-router"
import axios from "axios"
import {
  GET_DIVISIONS_WATCHER,
  GET_DIVISIONS_CHILDS_WATCHER,
  GET_INDICATOR_WATCHER,
  GET_FILTERS_WATCHER,
  GET_MEASURE_WATCHER,
  GET_MEASURE_COLOR_RANGE_WATCHER,
  GET_MEASURE_INFO_SEGMENT_WATCHER,
  GET_DIVISIONS_ROWS_WATCHER,
} from "./constants"

import {
  getHeadersSuccess,
  getDivisionsSuccess,
  getIndicatorSuccess,
  getFiltersSuccess,
  getMeasureSuccess,
  getMeasureColorRangeSuccess,
  getMeasureInfoSegmentSuccess,
  getMeasureInfoSegmentFailed,
  getDivisionsRowsSuccess,
} from "./actions"
import { getMeasureReportApi } from "../../../utils/routes/routes-report"
import { addLevel } from "utils/utils"
import { isEmpty } from "lodash"
import { LOCAL_TOKEN } from "../../../utils/storage"

// Get indicator
function getIndicatorApi(params) {
  return axios.request({
    method: "GET",
    cancelToken: params.token,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}reports/measure/${params.payload.measure}/metrics/${params.payload.id}`,
    params: params.payload.params,
  })
}

// Get dimensions
function getDivisionsApi(params) {
  try {
    let url = ""
    let objFilter
    if (params.payload.leader) {
      url = `reports/measure/${params.payload.measure}/leaders/metrics`
      if (params.payload.filter && params.payload.filter != "all") {
        url = `reports/measure/${params.payload.measure}/segment/${params.payload.filter}`
      }
      objFilter = { "filter[positionParent]": params.payload.id_division }
    } else {
      url = `reports/measure/${params.payload.measure}/metrics`
      if (params.payload.filter && params.payload.filter != "all") {
        url = `reports/measure/${params.payload.measure}/segment/${params.payload.filter}`
      }
      objFilter = { "filter[divisionParent]": params.payload.id_division }
    }

    const paramSegment =
      params.payload.id_segment ||
      (params.payload.params && params.payload.params.id_segment)

    const passParams =
      params.payload && params.payload.id_division ? objFilter : {}

    return axios.request({
      method: "GET",
      headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
      url: `${process.env.API_URL + url}`,
      params: {
        ...passParams,
        ...params.payload.params,
        id_segment: paramSegment,
        page: params.payload.page ? params.payload.page : 1,
      },
    })
  } catch (error) {
    console.log(error)
  }
}

// Get Measure Color
function getMeasureColorRangeApi(params) {
  return axios.request({
    method: "GET",
    cancelToken: params.token,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}reports/measure/${params.payload.measure}/color-range`,
  })
}

// Get Measure
function getMeasureApi(params) {
  return axios.request({
    method: "GET",
    cancelToken: params.token,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}measure/${params.payload.measure}`,
  })
}

export function* getDivisionsSaga(params) {
  try {
    const { data, status } = yield call(getDivisionsApi, params)
    const divisions = JSON.parse(JSON.stringify(data.data.data))
    const divisionsHeaders = JSON.parse(JSON.stringify(data.data.data))
    // Divisions
    divisions.map((e) => {
      const newHeaderDiv = []
      e.dimensions.map((x) => {
        const checkD = newHeaderDiv.filter(
          (e2) => e2.id_dimension === x.id_dimension
        )
        if (checkD.length === 0) {
          newHeaderDiv.push(x)
        }
      })

      let restOfDimensions = generateTreeHeader(
        "id_dimension",
        "id_dimension_parent",
        newHeaderDiv
      )
      restOfDimensions = changePositionByIndex(
        restOfDimensions,
        restOfDimensions.findIndex(
          (rOd) =>
            rOd.id_dimension_parent === null &&
            !rOd.engagement &&
            rOd.id_dimension === null
        )
      )
      if (params.payload.isEngagement) {
        restOfDimensions = changePositionByIndex(
          restOfDimensions,
          restOfDimensions.findIndex(
            (rOd) => rOd.id_dimension_parent === null && rOd.engagement
          )
        )
      }
      e.dimensions = restOfDimensions
    })
    // EndDivisions
    if (status === 200) {
      divisions.forEach(addLevel(1))
      if(params.payload?.page <= 1){
        yield put(
          getDivisionsSuccess({
            divisions,
            employees: data.data.employees,
            measure_id_segment: data.data.measure_id_segment,
            measure_segment_name: data.data.measure_segment_name,
            lastPage: data.data.lastPage
          })
        )
      }else{
        yield put(
          getDivisionsRowsSuccess({
            divisions,
            employees: data.data.employees,
            measure_id_segment: data.data.measure_id_segment,
            measure_segment_name: data.data.measure_segment_name,
            lastPage: data.data.lastPage
          })
        )

      }
      const newHeader = []
      divisionsHeaders[0].dimensions.map((x) => {
        const check = newHeader.filter((e) => e.id_dimension === x.id_dimension)
        if (check.length === 0) {
          newHeader.push(x)
        }
      })

      let arrayData = generateTreeHeader(
        "id_dimension",
        "id_dimension_parent",
        newHeader
      )
      arrayData = changePositionByIndex(
        arrayData,
        arrayData.findIndex(
          (rOd) =>
            rOd.id_dimension_parent === null &&
            !rOd.engagement &&
            rOd.id_dimension === null
        )
      )
      if (params.payload.isEngagement) {
        arrayData = changePositionByIndex(
          arrayData,
          arrayData.findIndex(
            (rOd) => rOd.id_dimension_parent === null && rOd.engagement
          )
        )
      }
      yield put(getHeadersSuccess(arrayData))
    }
  } catch (e) {
    console.log(e)
    const result = e
    switch (result && result.response && result.response.status) {
      case 404:
        yield put(push("/error"))
        break
    }
  }
}

export function* getDivisionsChildsSaga(params) {
  // type = 1 será añadir, 2 será para borrar.
  try {
    const { props, item, type } = params.payload
    const arr = []
    arr.push(item)
    let inicial = arr
    const positionINDEX = recursiveFindIndex(arr, item.id_division)
    positionINDEX.map((obj) => {
      inicial = inicial[obj]
    })
    inicial.childs = skeletonDivision(item.division_childs, item)
    if (type === 2) {
      inicial.childs = []
      yield put(getDivisionsSuccess({ divisions: props }))
    } else {
      const { data, status } = yield call(getDivisionsApi, params)
      const divisions = JSON.parse(JSON.stringify(data.data.data))
      divisions.map((e) => {
        let restOfDimensions = generateTreeHeader(
          "id_dimension",
          "id_dimension_parent",
          e.dimensions
        )
        restOfDimensions = changePositionByIndex(
          restOfDimensions,
          restOfDimensions.findIndex(
            (rOd) =>
              rOd.id_dimension_parent === null &&
              !rOd.engagement &&
              rOd.id_dimension === null
          )
        )

        if (params.payload.isEngagement) {
          restOfDimensions = changePositionByIndex(
            restOfDimensions,
            restOfDimensions.findIndex(
              (rOd) => rOd.id_dimension_parent === null && rOd.engagement
            )
          )
        }
        e.dimensions = restOfDimensions
      })
      divisions.forEach(addLevel(item.level + 1))
      inicial.childs = divisions
      if (status === 200) {
        yield put(getDivisionsSuccess({ divisions: props }))
      }
    }
  } catch (e) {
    console.error("ERROR DIVISIONS CHILD", e)
  }
}

// Get Indicator
export function* getIndicatorSaga(params = false) {
  const cancelSource = axios.CancelToken.source()
  try {
    params.token = cancelSource.token
    const { data, status } = yield call(getIndicatorApi, params)
    if (status === 200) {
      yield put(getIndicatorSuccess(data.data[0]))
    }
  } catch (e) {
  } finally {
    if (yield cancelled()) {
      cancelSource.cancel()
    }
  }
}

// Aditional functions

const generateTreeHeader = (id, id_parent, arr, parent_name, name) => {
  const tree = []
  const mappedArr = {}
  let arrElem
  let mappedElem

  for (let i = 0, len = arr.length; i < len; i++) {
    arrElem = arr[i]
    mappedArr[arrElem[id]] = arrElem
    mappedArr[arrElem[id]].childs = []
  }
  for (var id in mappedArr) {
    if (mappedArr.hasOwnProperty(id)) {
      mappedElem = mappedArr[id]
      if (mappedElem[id_parent]) {
        if (mappedArr[mappedElem[id_parent]]) {
          mappedArr[mappedElem[id_parent]].childs.push(mappedElem)
        } else {
          tree.push(mappedElem)
        }
      } else {
        tree.push(mappedElem)
      }
    }
  }
  return tree
}

const skeletonDivision = (t, item) => {
  const items = []
  const totalColumns = document.getElementsByClassName("verticalText").length
  for (let i = 1; i <= t; i++) {
    const maximum = 100000
    const minimum = 8000
    const random = Math.floor(Math.random() * (maximum - minimum + 1)) + minimum
    const dimensions = []
    for (let c = 1; c <= totalColumns; c++) {
      dimensions.push({
        childs: [],
        color: "#fff",
        dimension_name: null,
        id_dimension: null,
        id_dimension_parent: null,
        skeleton: true,
        value: "50.00",
      })
    }
    items.push({
      division_childs: 0,
      level: item.level + 1,
      division_name: "---",
      id_division: random,
      skeleton: true,
      dimensions,
    })
  }
  return items
}

const recursiveFindIndex = (data, id) =>
  data.reduce((indexes, item, index) => {
    let subIndex
    if (Array.isArray(item.childs)) {
      subIndex = recursiveFindIndex(item.childs, id)
    }
    if (subIndex && subIndex.length) {
      return indexes.concat([index], ["childs"], subIndex)
    }
    if (item.id_division === id) {
      indexes.push(index)
    }
    return indexes
  }, [])

const recursiveFindChildsId = (array = [], data) => {
  array.push(data.id)
  if (data.childs && data.childs.length > 0) {
    data.childs.map((e) => recursiveFindChildsId(array, e))
  }
  return array
}

const changePositionByIndex = (arrayData, Index) => {
  arrayData.splice(0, 0, arrayData[Index])
  arrayData.splice(Index + 1, 1)
  return arrayData
}

export function* getFiltersSaga(params) {
  try {
    const searchLocation = getUrlParams(location.search)
    let paramsPath = { ...searchLocation }
    let response = {}
    if (
      !isEmpty(paramsPath.id_divisionParent) &&
      paramsPath.id_divisionParent !== undefined
    ) {
      response = {
        id_division: searchLocation.id_divisionParent,
      }
    }
    response.id_segment = params.payload.id_segment

    const { data } = yield call(fetchGlobalApi, {
      method: "GET",
      endpoint: `reports/measure/${params.payload.measure}/divisions`,
      params: response,
    })


    yield put(
      getFiltersSuccess({
        divisions: data.data,
        divisionsTotal: data.metric_total,
      })
    )
  } catch (e) {
    console.log("ERROR GET FILTERS", e)
  }
}

export function* getMeasureColorRangeSaga(params) {
  const cancelSource = axios.CancelToken.source()
  try {
    params.payload.token = cancelSource.token
    const response = yield call(getMeasureColorRangeApi, params)

    yield put(getMeasureColorRangeSuccess(response.data.data))
  } catch (e) {
  } finally {
    if (yield cancelled()) {
      cancelSource.cancel()
    }
  }
}

export function* getMeasureSaga(params) {
  try {
    const { data, status } = yield call(getMeasureApi, params)
    if (status === 200) {
      yield put(
        getMeasureSuccess({
          measure: data.measure,
        })
      )
    }
  } catch (e) {}
}

export function* getMeasureInfoSaga(params) {
  try {
    const { data } = yield call(getMeasureReportApi, params.payload)
    if (data) {
      yield put(getMeasureInfoSegmentSuccess(data))
    }
  } catch (e) {
    getMeasureInfoSegmentFailed()
  }
}

// Individual exports for testing
export default function* comparativeAnalysisSaga() {
  yield takeLatest(GET_DIVISIONS_WATCHER, getDivisionsSaga)
  yield takeLatest(GET_DIVISIONS_ROWS_WATCHER, getDivisionsSaga)
  yield takeLatest(GET_DIVISIONS_CHILDS_WATCHER, getDivisionsChildsSaga)
  yield takeLatest(GET_INDICATOR_WATCHER, getIndicatorSaga)
  yield takeLatest(GET_FILTERS_WATCHER, getFiltersSaga)
  yield takeLatest(GET_MEASURE_WATCHER, getMeasureSaga)
  yield takeLatest(GET_MEASURE_COLOR_RANGE_WATCHER, getMeasureColorRangeSaga)
  yield takeLatest(GET_MEASURE_INFO_SEGMENT_WATCHER, getMeasureInfoSaga)
}
